import {HLineLight, MobileProfileWrapper, ProfileField} from "widgets/profile/ui/styles.ts";
import {useUserStore} from "entities/user";
import {formatDate} from "date-fns";
import {useResize} from "../../../../app/lib/hooks/useResize.ts";


export const ProfileInfo = () => {
  const userInfo = useUserStore((s) => s.userInfo);
  const { isScreenMd } = useResize()
  
  const DATA: Record<string, string> = {
    'Фамилия': userInfo?.name.last || '',
    'Имя': userInfo?.name.first || '',
    'Отчество': userInfo?.name.patronymic || '',
    'Дата рождения': userInfo?.profile.birthday ? formatDate(userInfo.profile.birthday, 'dd.MM.yyyy') : '',
    'Город': userInfo?.address.city || '',
    'Почта': userInfo?.credentials.email || '',
    'Телефон': userInfo?.credentials.login || ''
  }
  
  if (isScreenMd) return (
    <>
      {Object.entries(DATA).map(
        ([label, value], index) => (
          <ProfileField style={{order: index}} key={label}>
            <span>{label}</span>
            <span>{value}</span>
          </ProfileField>
        )
      )}
    </>
  )
  
  return (
    <MobileProfileWrapper>
      {Object.entries(DATA).map(
        ([label, value], index) => (
          <ProfileField style={{order: index}} key={label}>
            <span>{label}</span>
            <span>{value}</span>
          </ProfileField>
        )
      )}
      <HLineLight/>
    </MobileProfileWrapper>
  )
}